import React, { useState, useEffect } from "react";
import { Grid, Button, Typography, Box, Input, useTheme } from "@mui/material";
import { FormWrapper } from "../components/_dashboard/user";
import Page from "../components/Page";
import { InputField } from "../components/_dashboard/user";
import {
  uploadImage,
  updateImage,
  db,
} from "../database/db";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { SyncLoader } from "react-spinners";
import { useTranslation } from "react-i18next";

const TokenSettings = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [tokenConfig, setTokenConfig] = useState({
    name: "Fire Token",
    imageUrl: "",
    imageFilename: "",
    valueUsd: 0.10,
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");

  useEffect(() => {
    fetchTokenConfig();
  }, []);

  const fetchTokenConfig = async () => {
    setLoading(true);
    try {
      const docRef = doc(db, "AppConfig", "token");
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setTokenConfig(docSnap.data());
        setPreviewUrl(docSnap.data().imageUrl);
      }
    } catch (error) {
      console.error("Error fetching token config:", error);
    } finally {
      setLoading(false);
    }
  };

  const HandleChange = (e) => {
    const { name, value } = e.target;
    setTokenConfig({ ...tokenConfig, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      let finalUrl = tokenConfig.imageUrl;
      let finalFilename = tokenConfig.imageFilename;

      if (selectedFile) {
        const date = new Date();
        const fileName = date.getTime().toString();
        const extension = selectedFile.name.split(".").pop();
        const newPath = `config/token_${fileName}.${extension}`;
        
        finalUrl = await uploadImage(selectedFile, newPath);
        finalFilename = `token_${fileName}.${extension}`;
      }

      const updatedConfig = {
        ...tokenConfig,
        imageUrl: finalUrl,
        imageFilename: finalFilename,
        valueUsd: Number(tokenConfig.valueUsd),
      };

      await setDoc(doc(db, "AppConfig", "token"), updatedConfig);
      alert("Token Settings Updated!");
    } catch (error) {
      console.error("Error updating token settings:", error);
      alert("Failed to update settings.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Page title="Finance | Token Settings">
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <FormWrapper title="Global Token Settings">
            <Grid container spacing={2} sx={{ p: 3 }}>
              <Grid item xs={12}>
                <InputField
                  label="Token Name"
                  name="name"
                  value={tokenConfig.name}
                  onChange={HandleChange}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <InputField
                  label="Token Value (USD)"
                  name="valueUsd"
                  type="number"
                  value={tokenConfig.valueUsd}
                  onChange={HandleChange}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={loading}
                  sx={{ backgroundColor: "info.main" }}
                >
                  {loading ? <SyncLoader size={8} color="#fff" /> : "Save Changes"}
                </Button>
              </Grid>
            </Grid>
          </FormWrapper>
        </Grid>

        <Grid item xs={12} md={4}>
          <FormWrapper title="Token Icon / Animation">
            <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box
                sx={{
                  width: 150,
                  height: 150,
                  bgcolor: 'background.neutral',
                  borderRadius: 2,
                  overflow: 'hidden',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 2,
                  border: '1px dashed grey'
                }}
              >
                {previewUrl ? (
                  <img src={previewUrl} alt="Token Preview" style={{ maxWidth: '100%', maxHeight: '100%' }} />
                ) : (
                  <Typography variant="caption">No Image</Typography>
                )}
              </Box>
              
              <label htmlFor="token-icon-upload">
                <input
                  accept="image/*,video/*"
                  id="token-icon-upload"
                  type="file"
                  style={{ display: 'none' }}
                  onChange={handleImageChange}
                />
                <Button variant="outlined" component="span">
                  {tokenConfig.imageUrl ? "Change Icon" : "Upload Icon"}
                </Button>
              </label>
              <Typography variant="caption" sx={{ mt: 1, color: 'text.secondary' }}>
                Supports PNG, GIF, or Small Video/Animation
              </Typography>
            </Box>
          </FormWrapper>
        </Grid>
      </Grid>
    </Page>
  );
};

export default TokenSettings;
